var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"btn btn-up",attrs:{"aria-label":"scroll to top"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('ppicon',{staticClass:"btn-icon",attrs:{"name":"chevron-up","large":"","alt":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }